import React, { Component } from 'react'

import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { Editor, Block, addNewBlock, BLOCK_BUTTONS } from 'medium-draft'

import 'medium-draft/lib/index.css'
import './MediumDraft.css'

const BLOCKQUOTE_BUTTON = BLOCK_BUTTONS[1]

class ImageButton extends Component {
  onFileUpload = url => {
    this.props.setEditorState(
        addNewBlock(this.props.getEditorState(), Block.IMAGE, {
          src: url,
        }),
    )
    this.props.close()
  }

  onClick = () => {
    this.input.value = null
    this.input.click()
  }

  render() {
    return (
        <Mutation
            mutation={UPLOAD_FILE_MUTATION}
            update={(cache, { data: { uploadFile } }) => {
              this.onFileUpload(uploadFile.url)
            }}
        >
          {uploadFile => (
              <button
                  className="md-sb-button md-sb-img-button"
                  type="button"
                  onClick={this.onClick}
                  title="Add an Image"
              >
                <i className="fa fa-image" />
                <input
                    type="file"
                    accept="image/*"
                    ref={c => {
                      this.input = c
                    }}
                    onChange={event => {
                      const file = event.target.files[0]
                      uploadFile({ variables: { file } })
                    }}
                    style={{ display: 'none' }}
                />
              </button>
          )}
        </Mutation>
    )
  }
}

export default class MediumEditor extends Component {
  config = {
    blockButtons: [
      {
        label: 'H1',
        style: 'header-four',
        icon: 'header',
        description: 'Title',
      },
      {
        label: 'H2',
        style: 'header-five',
        icon: 'header',
        description: 'Subtitle',
      },
      {
        label: 'UL',
        style: 'unordered-list-item',
        icon: 'list-ul',
        description: 'Unordered List',
      },
      {
        label: 'OL',
        style: 'ordered-list-item',
        icon: 'list-ol',
        description: 'Ordered List',
      },
      {
        ...BLOCKQUOTE_BUTTON,
      },
    ],
    inline: ['BOLD', 'ITALIC', 'hyperlink'],
  }
  render() {
    return (
      <div
        style={{
          maxWidth: '620px',
          margin: '0 auto',
          paddingBottom: '30px',
        }}
      >
        <Editor
          ref="editor"
          editorState={this.props.editorState}
          onChange={this.props.handleEditorChange}
          blockButtons={this.config.blockButtons}
          toolbarConfig={{ inline: this.config.inline }}
          sideButtons={[
            {
              title: 'Image',
              component: ImageButton,
            },
          ]}
          placeholder="Write content body text here..."
        />
      </div>
    )
  }
}

const UPLOAD_FILE_MUTATION = gql`
  mutation UploadFile($file: Upload!) {
    uploadFile(file: $file) {
      url
    }
  }
`
